import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Tab as BootstrapTab, Tabs as BootstrapTabs } from 'react-bootstrap';
import { useNavigate  } from 'react-router-dom';

import { useNotification } from 'config/Notification';

import { 
  // fetchStandards as fetchStandardsService, 
  fetchSelectedStandardsById as fetchSelectedStandardsByIdService,
  updateStandards as updateStandardsService,
  fetchCompanyStandardsByCompany as fetchStandardsService
} from 'services/modules/cap/standardservice';

import Button from '@mui/material/Button';
import ArrowLeftIcon from '@mui/icons-material/ArrowLeft';
import { CircularProgress } from '@mui/material';

import { GrCompliance } from "react-icons/gr";

const StandardsPage = () => {

  // State variables
  const [loading,setLoading] = useState(true);
  const [domainStandards, setDomainStandards] = useState([]);
  const [mainStandards, setMainStandards] = useState([]);
  const [selectedStandardsResponse, setSelectedStandardsResponse] = useState({
    predefined_standards: [],
    selected_standards: [], 
  });
  const [selectedTab, setSelectedTab] = useState('1');

  // Redux selectors
  const selectedCompanyContainer = useSelector((state) => state.auth.companyData);

  // React router
  const navigate = useNavigate();

  // Notification
  const { openNotification } = useNotification();
 
  // Method to fetch the standards data of company
  const fetchStandardsData = async () => {
    try {
      const companyId = selectedCompanyContainer.companyid;
      let group = 'Main Standard';
      const mainStandardResponse = await fetchStandardsService({group, companyId});
      group = 'Domain Standard';
      const domainStandardResponse = await fetchStandardsService({group, companyId});
      const selectedStandardsResponse = await fetchSelectedStandardsByIdService({companyId});
        
      setMainStandards(mainStandardResponse.data);
      setDomainStandards(domainStandardResponse.data);
      setSelectedStandardsResponse(selectedStandardsResponse.data);
    } catch (error) {
      openNotification("Error while fetching data", 'error');
    }
    finally{
      setLoading(false);
    }
  };

  useEffect(() => {
    if (selectedCompanyContainer?.companyid !== null) {
      fetchStandardsData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedCompanyContainer]);

  // Method handles to save the changes in standards
  const handleSubmit = async () => {
    try {
      const mainStandardPayload = {
        company: selectedCompanyContainer.companyid,
        selected_standards: selectedStandardsResponse[0]?.selected_standards || [],
      };
      const domainStandardPayload = {
        company: selectedCompanyContainer.companyid,
        predefined_standards: selectedStandardsResponse[0]?.predefined_standards || [],
      };

      const updatedMainStandardResponse = await updateStandardsService(mainStandardPayload);
      const updatedDomainStandardResponse = await updateStandardsService(domainStandardPayload);

      if (updatedMainStandardResponse.status === 200 || updatedDomainStandardResponse.status === 200) {
        openNotification("Please complete pending assessment before changing the standards", 'error');
        fetchStandardsData();
      } else if (updatedMainStandardResponse.status === 201 && updatedDomainStandardResponse.status === 201) {
        openNotification("Standards assigned successfully", 'success', updatedDomainStandardResponse, updatedMainStandardResponse);
      }
    } catch (error) {
      openNotification('Error while assigning standards', 'error');
    }
  };

  return (
   <div className="position-relative">
          {loading && (
            <div className="card-loader-overlay">
              <CircularProgress size={60} />
            </div>
          )}
    <div className='standards-container-1 p-4'>
      <div>
        <div>
          <h2 className="standard-text">Standards</h2>
        </div>
        <div className='std-label'>
          <p >(Please select your preferred standards. See our <a className='forgottext' href onClick={()=> navigate(`/cap/standardsguide`)}>Standards guidance</a> for more information )</p>
        </div>
        <div className="card" >
          <div>
            <BootstrapTabs
              activeKey={selectedTab}
              onSelect={(key) => setSelectedTab(key)}
              justify
              className='custom-tab-styles'
            >
              <BootstrapTab eventKey="1" title="Standard Based">
                <div className="row card-width" >
                  {mainStandards.map((mainStandard) => (
                    <div key={mainStandard.id} className="col-lg-5 col-md-5 col-sm-12 m-3">
                      <div className="card standard-container card-width" >
                        <div className='card-box'>
                          <div className="form-check m-2">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              value={mainStandard.name}
                              id={`mainStandardCheckbox-${mainStandard.stdid}`}
                              checked={selectedStandardsResponse[0]?.selected_standards?.includes(mainStandard.stdid) || false}
                              onChange={(e) => {
                                const stdid = mainStandard.stdid; // Get the standard ID directly from the mainStandard object
                                setSelectedStandardsResponse((prev) => {
                                  const selected_standards = prev[0]?.selected_standards || [];
                                  const updatedStandards = e.target.checked
                                    ? [...selected_standards, stdid] // Add the stdid if checked
                                    : selected_standards.filter((standard) => standard !== stdid); // Remove stdid if unchecked
                                  return [{ ...prev[0], selected_standards: updatedStandards }];
                                });
                              }}
                            />
                          </div>
                          <div>
                            {mainStandard.name === 'CIS' && <img src="../../../../../assets/CIS.png" alt="cis" className="standard-img" />}
                            {mainStandard.name === 'NIST' && <img src="../../../../../assets/NIST.png" alt="nist" className="standard-img"/>}
                            {mainStandard.name === 'ISO-27001' && <img src="../../../../../assets/ISO.png" alt="ISO-27001" className="standard-img"/>}
                            {mainStandard.name === 'COBIT' && <img src="../../../../../assets/COBIT.png" alt="cis" className="standard-img"/>}
                            {mainStandard.name === 'TISAX' && <img src="../../../../../assets/TISAX.png" alt="cis" className="standard-img"/>}
                            { !['TISAX', 'CIS', 'NIST', 'ISO-27001', 'COBIT'].includes(mainStandard.name) && <GrCompliance className="standard-img" />}          
                          </div>
                          <label className="standard-label">{mainStandard.name}</label>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </BootstrapTab>

              <BootstrapTab eventKey="2" title="Domain Based">
                <div className="row card-width" >
                  {domainStandards.map((domainStandard) => (
                    <div key={domainStandard.id} className="col-lg-5 col-md-5 col-sm-12 m-3">
                      <div className="card standard-container " >
                        <div className='card-box'>
                          <div className="form-check m-2">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              value={domainStandard.name}
                              id={`domainStandardCheckbox-${domainStandard.stdid}`}
                              checked={selectedStandardsResponse[0]?.predefined_standards?.includes(domainStandard.stdid) || false}
                              onChange={(e) => {
                                const stdid = domainStandard.stdid; // Get the standard ID directly from the domainStandard object
                                setSelectedStandardsResponse((prev) => {
                                  const predefined_standards = prev[0]?.predefined_standards || [];
                                  const updatedStandards = e.target.checked
                                    ? [...predefined_standards, stdid] // Add the stdid if checked
                                    : predefined_standards.filter((standard) => standard !== stdid); // Remove stdid if unchecked
                                  return [{ ...prev[0], predefined_standards: updatedStandards }];
                                });
                              }}
                            />
                          </div>
                          <div>
                            {domainStandard.name === 'NIS 2.0' && <img src="../../../../../assets/NIS.png" alt="nis" className="standard-img" />}
                            {domainStandard.name === 'Ransomware' && <img src="../../../../../assets/RANSOMWARE.png" alt="ransomware" className="standard-img"/>}
                            {domainStandard.name === 'Data Protection' &&   <img src="../../../../../assets/DataProtection.png" alt="Data Protection" className="standard-img"/>}
                            {domainStandard.name === 'Supplier Risk' && <img src="../../../../../assets/SUPPLIERRISK.png" alt="Supplier Risk" className="standard-img"/>}
                            { !['NIS 2.0', 'Ransomware', 'Data Protection', 'Supplier Risk'].includes(domainStandard.name) && <GrCompliance className="standard-img" />}                
                          </div>
                          <label className="standard-label">{domainStandard.name}</label>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </BootstrapTab>
            </BootstrapTabs>
          </div>
        </div>

        <div className='dailogBox m-3'>   
          <Button variant="contained"   className='card-button user-button' onClick={()=> window.history.back()}> <ArrowLeftIcon /> Back</Button>
          <Button variant="contained" className='card-button user-button user-button-1'  onClick={handleSubmit}> Save</Button>
        </div>      
      </div>
    </div>
    </div>
  );
};

export default StandardsPage;